import { createApp } from "vue"

// Every .vue file in app/frontend/vue/components is registered by its basename,
// so `vue_component "Greeting"` in a view mounts components/Greeting.vue.
const modules = import.meta.glob("./components/**/*.vue", { eager: true })

const components = Object.fromEntries(
  Object.entries(modules).map(([path, module]) => {
    const name = path.replace(/^\.\/components\//, "").replace(/\.vue$/, "")
    return [name, module.default]
  })
)

// Mounts a Vue app onto each [data-vue-component] element on the page, passing
// the JSON in data-vue-props through as props.
export function mountVueComponents(root = document) {
  root.querySelectorAll("[data-vue-component]").forEach((el) => {
    const name = el.dataset.vueComponent
    const component = components[name]

    if (!component) {
      console.error(`Vue component "${name}" not found. Known: ${Object.keys(components).join(", ")}`)
      return
    }

    const props = el.dataset.vueProps ? JSON.parse(el.dataset.vueProps) : {}
    createApp(component, props).mount(el)
  })
}
